type Step = {
  step: string;
  title: string;
  description: string;
};

type Props = {
  items: Step[];
};

export function NumberedList({ items }: Props) {
  return (
    <ol className="grid gap-10 md:gap-12">
      {items.map((item) => (
        <li key={item.step} className="grid grid-cols-[auto_1fr] gap-6 md:gap-10 items-start">
          <span className="font-display text-5xl md:text-6xl font-light text-accent leading-none">
            {item.step}
          </span>
          <div className="flex flex-col gap-2 pt-2">
            <h3 className="font-display text-2xl md:text-3xl font-medium">{item.title}</h3>
            <p className="text-ink-secondary leading-relaxed max-w-xl">{item.description}</p>
          </div>
        </li>
      ))}
    </ol>
  );
}
